<template>
  <section class="about-us-team text-left">
    <div class="page-container">
      <h2 class="about-us-team__title pr6">
        Bravado is&nbsp;built for salespeople,
        <em>by</em>
        &nbsp;salespeople
      </h2>

      <p class="about-us-team__subtitle">
        Every leader at&nbsp;Bravado has sold before. That&rsquo;s what drives their passion to&nbsp;demand respect for
        salespeople and build the tools they need to&nbsp;succeed.
      </p>

      <div class="about-us-team__people grid justify-center locked py6">
        <BravadoAvatar
          v-for="member in team"
          :key="member.name + member.title"
          width="150"
          height="150"
          :item="member"
          data-aos="fade-up"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from 'vue';
import { team } from '../constants';
import BravadoAvatar from '~/components/partials/landings/ui/BravadoAvatar.vue';

export default Vue.extend({
  name: 'AboutUsTeam',
  components: { BravadoAvatar },
  data() {
    return {
      team,
    };
  },
});
</script>

<style lang="scss" scoped>
.about-us-team {
  padding: 42px 0 28px;

  @include mq('md') {
    padding: 105px 0 90px;
    text-align: center;
  }

  &__title {
    font-weight: 600;
    color: var(--white);
    max-width: 690px;
    margin: 0 auto 16px;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: -0.5px;

    @include mq('md') {
      font-size: 49px;
      line-height: 60px;
      letter-spacing: -1.45366px;
      margin: 0 auto 20px;
      padding: 0;
    }

    em {
      color: var(--theme-purple_hc_1);
    }
  }

  &__subtitle {
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    color: var(--gray-20);
    max-width: 710px;
    margin: 0 auto 16px;

    @include mq('md') {
      font-size: 17px;
      line-height: 30px;
      letter-spacing: 0.35366px;
      margin: 0 auto 65px;
    }
  }

  &__people {
    max-width: 850px;
    margin: 0 auto 40px;
    gap: 30px 0;
    grid-template-columns: repeat(2, 1fr);

    @include mq('md') {
      padding: 40px 0;
      gap: 70px 0;
      grid-template-columns: repeat(3, 1fr);
    }
  }
}
</style>
